import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import { GetAllEmployees, getInvPartsByFilter, ReceiveGpuApi } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import { useStateContext } from "../../contexts/ContextProvider";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import DoubleField from "../../components/DoubleField";
import SelectField from "../../components/SelectField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";
import DateTimeField from "../../components/DateTimeField";

const ReceiveGpu = () => {
  const navigate = useNavigate();
  const { storeG, currentColor, userID } = useStateContext();
  const [getParts, setParts] = useState([]);
  const [getEmployees, setEmployees] = useState([]);
  const [snList, setSnList] = useState([]);
  const [snAutoList, setSnAutoList] = useState([]);
  const [formData, setFormData] = useState({
    part: "Select Part",
    gpu_name: "",
    specs: "",
    detail: "",
    box_qrscan: "",
    sku: "",
    box_id: "",
    lot_no: "",
    qty: "1",
    employee: "Select Employee",
  });
  const [snData, setSnData] = useState({
    gpu_sn: "",
    other: "",
    note: "",
  });
  const [oDatetime, setODatetime] = useState("");
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/GpuWb");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "gpu_sn" || name === "other" || name === "note")
      setSnData((prev) => ({ ...prev, [name]: value }));
    else if (name === "qty")
      setFormData((prev) => ({ ...prev, [name]: parseInt(value) || 0 }));
    else if (name === "box_qrscan") {
      if (value.length > 28) {
        const strings = value.split("|");
        if (strings.length > 2) {
          let gpu_sns = [];
          for (let i = 2; i < strings.length; i++)
            if (strings[i]) gpu_sns.push(strings[i]);
          setFormData((prev) => ({
            ...prev,
            [name]: value,
            sku: strings[0],
            box_id: strings[1],
            qty: gpu_sns.length,
          }));
          if (gpu_sns.length > 0)
            setSnData((prev) => ({ ...prev, gpu_sn: gpu_sns[0] }));
          setSnAutoList(gpu_sns || []);
        }
      } else setFormData((prev) => ({ ...prev, [name]: value }));
    } else setFormData((prev) => ({ ...prev, [name]: value }));

    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      if (e.name === "part")
        setFormData((prev) => ({
          ...prev,
          [e.name]: option,
          gpu_name: option.label,
        }));
      else setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const handleNext = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    const newErrors = {};
    Object.keys(snData).forEach((key) => {
      const error = validateField(key, snData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    if (snList.some((item) => item.gpu_sn === snData.gpu_sn)) {
      showErrorToast("Duplicate GPU SN!", "This GPU SN already exists!");
      setLoadBtn(false);
      return;
    }
    const coun = snList.length + 1;
    setSnList((prev) => [
      ...prev,
      { gpu_sn: snData.gpu_sn, other: snData.other, note: snData.note },
    ]);
    const snn = snAutoList.length > coun ? snAutoList[coun] : "";
    setSnData((prev) => ({ ...prev, gpu_sn: snn, other: "", note: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    const snItems = snList.map((item, i) => ({
      name: formData.gpu_name,
      specs: formData.specs,
      detail: formData.detail,
      box_qrcode: formData.box_qrscan,
      qr_code: item.gpu_sn,
      lot_no: formData.lot_no,
      sku: formData.sku,
      box_id: formData.box_id,
      id_no1: "",
      id_no2: "",
      sn: "",
      gpu_sn: item.gpu_sn,
      test_result: "",
      other: item.other,
      notes: item.note,
    }));
    const reqData = {
      part_id: formData.part.value,
      store_id: storeG.store_id,
      employee_id: formData.employee.value,
      user_id: userID,
      recv_scan_date: oDatetime,
      gpus: snItems,
    };
    try {
      const response = await ReceiveGpuApi(reqData);
      if (response.success) {
        showSuccessToast("Success!", "GPUs Received successfully!");
        navigate("/GpuWb");
      } else
        showErrorToast("Error!", "GPUs failed to recv!\n\n" + response.message);
    } catch (err) {
      showErrorToast("Error!", "GPUs did not receive!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id) {
        TimeoutUtility.resetTimeout();
        var now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        setODatetime(now.toISOString().slice(0, 19));
        await GetAllEmployees()
          .then((resp) => {
            const employeeOptions = resp.data.map((item) => ({
              label: item.name,
              value: item.employee_id,
            }));
            setEmployees(employeeOptions || []);
          })
          .catch((err) => console.log(err.message));
        await getInvPartsByFilter(storeG?.store_id, null, 136)
          .then((resp) => {
            const partOptions = resp.data.map((item) => ({
              label: item.part_number + " - " + item.description,
              value: item.part_id,
            }));
            setParts(partOptions || []);
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [storeG]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="RECEIVE GPUS" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={8} lg={12} className="container-col">
              <SelectField
                label="Part:"
                name="part"
                value={formData.part}
                options={getParts}
                onChange={handleSelectChange}
                placeholder="Part"
                compulsory={true}
                error={errors.part}
              />
            </Col>
          </Row>
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={4} lg={6} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="Name:"
                  name="gpu_name"
                  value={formData.gpu_name}
                  onChange={handleChange}
                  placeholder="Name"
                  error={errors.gpu_name}
                />
                <TextInputField
                  label="Specs:"
                  name="specs"
                  value={formData.specs}
                  onChange={handleChange}
                  placeholder="Specs"
                  error={errors.specs}
                />
                <TextAreaField
                  label="Detail:"
                  name="detail"
                  value={formData.detail}
                  onChange={handleChange}
                  placeholder="Detail"
                  error={errors.detail}
                />
                <div style={{ marginTop: "94px" }} />
                <DoubleField
                  label="Recv Qty:"
                  name="qty"
                  value={formData.qty}
                  onChange={handleChange}
                  placeholder="Receive Quantity"
                  min="0"
                  step="1.00"
                  compulsory={true}
                  error={errors.qty}
                />
                <SelectField
                  label="Recv Operator:"
                  name="employee"
                  value={formData.employee}
                  options={getEmployees}
                  onChange={handleSelectChange}
                  placeholder="Operator"
                  compulsory={true}
                  error={errors.employee}
                />
                <DateTimeField
                  label="Recv Datetime:"
                  name="recv_date"
                  value={oDatetime}
                  placeholder="DateTime"
                  now={false}
                  formField={true}
                  disabled
                />
              </div>
            </Col>
            <Col xl={4} lg={6} className="container-col">
              <div className="col-lg-12">
                <TextAreaField
                  label="Box QR Scan:"
                  name="box_qrscan"
                  value={formData.box_qrscan}
                  onChange={handleChange}
                  placeholder="Box QR Scan"
                  error={errors.box_qrscan}
                />
                <TextInputField
                  label="SKU:"
                  name="sku"
                  value={formData.sku}
                  onChange={handleChange}
                  placeholder="SKU"
                  error={errors.sku}
                  compulsory={true}
                />
                <TextInputField
                  label="Box ID:"
                  name="box_id"
                  value={formData.box_id}
                  onChange={handleChange}
                  placeholder="Box ID"
                  error={errors.box_id}
                  compulsory={true}
                />
                <TextInputField
                  label="Lot #:"
                  name="lot_no"
                  value={formData.lot_no}
                  onChange={handleChange}
                  placeholder="Lot #"
                  error={errors.lot_no}
                />
                <Row sm={1} className="p-0 justify-content-center">
                  <Col md={2} className="pt-3 container-col">
                    {parseInt(formData.qty) <= snList.length
                      ? "-"
                      : `${snList.length + 1}.`}
                  </Col>
                  <Col md={10} className="container-col">
                    <TextInputField
                      label="GPU SN:"
                      name="gpu_sn"
                      value={snData.gpu_sn}
                      onChange={handleChange}
                      placeholder="GPU SN"
                      error={errors.gpu_sn}
                      compulsory={true}
                      disabled={parseInt(formData.qty) <= snList.length}
                    />
                    <TextInputField
                      label="Other:"
                      name="other"
                      value={snData.other}
                      onChange={handleChange}
                      placeholder="Other"
                      error={errors.other}
                      disabled={parseInt(formData.qty) <= snList.length}
                    />
                    <TextAreaField
                      label="Note:"
                      name="note"
                      value={snData.note}
                      onChange={handleChange}
                      placeholder="Note"
                      error={errors.note}
                      disabled={parseInt(formData.qty) <= snList.length}
                    />
                    <Row md={"auto"} className="justify-content-center pr-12">
                      <button
                        type="button"
                        style={{
                          backgroundColor:
                            parseInt(formData.qty) <= snList.length
                              ? "gray"
                              : currentColor,
                          color: "#fff",
                          borderRadius: "10px",
                          padding: "12px",
                          margin: "4px",
                        }}
                        disabled={parseInt(formData.qty) <= snList.length}
                        className={`text-sm pt-2 pb-2 pl-3 pr-3 hover:drop-shadow-xl transition disabled:cursor-not-allowed`}
                        onClick={handleNext}
                      >
                        {parseInt(formData.qty) <= snList.length
                          ? "Finish"
                          : "Next"}
                      </button>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Create"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ReceiveGpu;
